import { useCallback } from "react";
import { gql, useMutation } from "@apollo/client";
import { GetAllFranchiseesQuery } from "./useAllFranchisees.ts";
import { GetFranchiseeByIdQuery } from "./useFranchiseeById.ts";
import { TeacherRole, TeacherTag } from "../gql/graphql.ts";

const UpdateTeacherMutation = gql`
  mutation updateTeacher(
    $id: String!
    $phoneNumber: PhoneNumberInput
    $userGroupIds: [String!]
    $lesson1on1: Boolean
    $roles: [TeacherRole!]
    $tags: [TeacherTag!]
  ) {
    updateTeacher(
      id: $id
      phoneNumber: $phoneNumber
      userGroupIds: $userGroupIds
      lesson1on1: $lesson1on1
      roles: $roles
      tags: $tags
    ) {
      id
    }
  }
`;

export type UpdateTeacherInput = {
  id: string;
  phoneNumber?: {
    countryCode: string;
    number: string;
  };
  userGroupIds?: string[];
  lesson1on1?: boolean;
  roles?: TeacherRole[];
  tags?: TeacherTag[];
};

export function useUpdateTeacher() {
  const [mutate, { loading }] = useMutation(UpdateTeacherMutation);

  const updateTeacher = useCallback(
    async (input: UpdateTeacherInput) => {
      await mutate({
        variables: {
          id: input.id,
          phoneNumber: input.phoneNumber,
          userGroupIds: input.userGroupIds,
          lesson1on1: input.lesson1on1,
          roles: input.roles,
          tags: input.tags,
        },
        refetchQueries: [
          { query: GetAllFranchiseesQuery },
          { query: GetFranchiseeByIdQuery, variables: { id: input.id } },
        ],
      });
    },
    [mutate],
  );

  return { updateTeacher, loading };
}
